import cn from 'classnames';
import React, { RefAttributes } from 'react';

import Widget from 'components/Widget/Widget';
import { DataProperties, NumberOfUnits } from 'types';
import { DEFAULT_NUMBER_OF_UNITS } from './constants';
import ThreeByOnePodcastInfo from './ThreeByOnePodcastInfo';
import ThreeByOneUnit from './ThreeByOneUnit';
import styles from './ThreeByOneWidget.module.scss';
import ThreeByOneWidgetGrid from './ThreeByOneWidgetGrid';
import ThreeByOneWidgetPlayer from './ThreeByOneWidgetPlayer';

export interface ThreeByOneWidgetProps
  extends Partial<Omit<NumberOfUnits, 'expectedNumberOfUnits'>>,
    DataProperties {
  children?: React.ReactNode;
  className?: string;
}

type ForwardedRefComponent = (
  props: ThreeByOneWidgetProps & RefAttributes<HTMLElement>,
) => React.ReactElement | null;

interface ThreeByOneWidgetComponent extends ForwardedRefComponent {
  Grid: typeof ThreeByOneWidgetGrid;
  Player: typeof ThreeByOneWidgetPlayer;
  PodcastInfo: typeof ThreeByOnePodcastInfo;
  Unit: typeof ThreeByOneUnit;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const ThreeByOneWidget: ThreeByOneWidgetComponent = React.forwardRef<
  HTMLElement,
  ThreeByOneWidgetProps
>(
  (
    {
      className,
      children,
      defaultNumberOfUnits = DEFAULT_NUMBER_OF_UNITS,
      maxNumberOfUnits,
      ...rest
    },
    ref,
  ) => (
    <Widget
      className={cn(styles.widget, className)}
      {...{ defaultNumberOfUnits, maxNumberOfUnits, ref }}
      {...rest}
    >
      {children}
    </Widget>
  ),
);

ThreeByOneWidget.Grid = ThreeByOneWidgetGrid;
ThreeByOneWidget.Player = ThreeByOneWidgetPlayer;
ThreeByOneWidget.PodcastInfo = ThreeByOnePodcastInfo;
ThreeByOneWidget.Unit = ThreeByOneUnit;

export default ThreeByOneWidget;
